export const text =
`
I wrote a book called Dear Human
`
